module.exports = __webpack_public_path__ + "media/images/lp_sakamoto_interview-c79b63cf2ac5a4628e31dd646c8cb842.webp";